import React from 'react';
import { observer } from 'mobx-react-lite';

import Container from '@vromo/ui/components/Container';
import { useStore } from '@vromo/mobx-react';

import styled from '@emotion/styled';
import { css } from 'emotion';

import TaskLatenessChart from './components/TaskLatenessChart';
import JobsBySiteChart from './components/JobsBySiteChart';
import JobsDurationChart from './components/JobsDurationChart';
import DrivingDistanceChart from './components/DrivingDistanceChart';
import EndToEndJobDurationChart from './components/EndToEndJobDurationChart';
import { Job } from 'models';

const SegmentRow = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`;

const Segment = css`
    flex: 1;
    padding: 20px;
    height: 300px;

    @media (max-width: 1000px) {
        flex: unset;
    }
`;

interface Props {
    startDate: Date;
    endDate: Date;
    jobs: Job[];
}

export default observer<Props>(function PerformanceReport({ startDate, endDate, jobs }) {
    const { siteStore } = useStore('rootStore');
    return (
        <div style={{ flex: 1 }}>
            <SegmentRow>
                <Container className={Segment} title="Task Lateness Breakdown">
                    <TaskLatenessChart jobs={jobs} startDate={startDate} />
                </Container>
                <Container className={Segment} title="Average Task Duration">
                    <JobsDurationChart jobs={jobs} startDate={startDate} endDate={endDate} />
                </Container>
            </SegmentRow>
            <SegmentRow>
                <Container className={Segment} title="Average Driving Distance">
                    <DrivingDistanceChart jobs={jobs} startDate={startDate} endDate={endDate} />
                </Container>
                <Container className={Segment} title="End to End Job Breakdown">
                    <EndToEndJobDurationChart jobs={jobs} startDate={startDate} endDate={endDate} />
                </Container>
            </SegmentRow>
            {siteStore?.sites?.length ? (
                <SegmentRow>
                    <Container className={Segment} title="Top Sites">
                        <JobsBySiteChart jobs={jobs} sites={siteStore.sites} />
                    </Container>
                </SegmentRow>
            ) : null}
        </div>
    );
});
